import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    background-color: #F3F3F3;

    .layout-page-container {
        padding: 12em 0 2.7em 0;
    }

    .content {
        padding: 5.4em 2.7em 2.7em 2.7em;
        background-color: #FFFFFF;
    }

@media all and (max-width:${variables.mobileL}) {
    background-color: #FFFFFF;

    .layout-page-container {
        padding: 6em 0;

        .layout-container {
            width: 100%;
        }
    }

    .content {
        padding: 3em 2em .7em;
        background-color: #FFFFFF;
    }
}
`;